import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const getRewardStatus = () =>
  fetch(buildUrl("/api/rewards/status"), {
    headers: jsonHeaders,
    credentials: "include",
  }).then(handleResponse);

export const validateRewardVoucher = (code) =>
  fetch(buildUrl("/api/rewards/validate"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ code }),
    credentials: "include",
  }).then(handleResponse);

export const redeemRewardVoucher = () =>
  fetch(buildUrl("/api/rewards/redeem"), {
    method: "POST",
    headers: jsonHeaders,
    credentials: "include",
  }).then(handleResponse);

const rewardsApi = {
  getRewardStatus,
  validateRewardVoucher,
  redeemRewardVoucher,
};

export default rewardsApi;
